import RequestHandler from './utils/request-handler.js';
import Selectors from './utils/selectors.js';

export default class GiftPopup {
    constructor(options = {}) {
        this.selectors = new Selectors();
        this.popupLinkSelector = options.popupLinkSelector || 'data-gift-popup';
        this.cachePopupSelector = options.cachePopupSelector || 'data-cached-modal-html';
        this.giftModalId = options.giftModalId || 'gift_modal';
        this.giftModal = document.querySelector(this.selectors.modalDataAttr(this.giftModalId));
        this.popupLinks = this.selectors.querySelectorArray(this.selectors.attrSelector(this.popupLinkSelector));
        this.giftURI = options.giftURI || '/ajax/gift.json';
        this.cachbackURI = options.cachbackURI || '/ajax/cashback.json';
        this.requestHandler = new RequestHandler;
    }

    setup() {
        if (this.popupLinks.length && this.giftModal) {
            this.setupEventListeners();
        }
    }

    cachedModal(element) {
        let cachedHtml = element.getAttribute(this.cachePopupSelector);
        if (cachedHtml) {
            this.giftModal.innerHTML = cachedHtml;
            $(this.giftModal).modal();
            return true;
        }
    }

    populateModal(self, el, response) {
        if (response.success) {
            self.giftModal.innerHTML = response.html;
            el.setAttribute(self.cachePopupSelector, response.html);
            $(self.giftModal).modal();
        }
    }

    setupEventListeners() {
        let self = this;
        this.popupLinks.forEach(function(el) {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                if (!self.cachedModal(el)) {
                    let popupRequestURI = self.giftURI,
                        options = {
                            'gift-code': el.getAttribute('data-gift-code')
                        };
                    if (el.getAttribute(self.popupLinkSelector) == 'cashback') {
                        popupRequestURI = self.cachbackURI;
                        options['price-id'] = el.getAttribute('data-price-id');
                        options['tariff-code'] = el.getAttribute('data-tariff-code');
                    }
                    self.requestHandler.post(popupRequestURI, options, self.populateModal.bind(this, self, el));
                }
            });
        });
    }
}
